import { createSlice } from '@reduxjs/toolkit';
import { defaultGenericState, GenericState } from '../model';
import { addGenericStateSingleBuilders } from '../slice';
import { startVerify } from './VerifyApi';
import { VerifyResponse } from './VerifyTypes';

export interface VerifyState extends GenericState<VerifyResponse> {
}

export const verifySlice = createSlice({
    name: 'Verify',
    initialState: defaultGenericState,
    reducers: {
        resetVerify: () => defaultGenericState,
    },
    extraReducers: builder => {
        addGenericStateSingleBuilders(builder, startVerify);
    },
});

export const { resetVerify } = verifySlice.actions;
